/**
 * Inline confirmation for the rollout actions that send email or cannot be
 * undone (tracker item 81). Same look as the confirm blocks on the customer
 * portal panel: an amber box with the consequence, then Yes / Cancel.
 */
import React from 'react';
import { primaryButtonClass, secondaryButtonClass } from '../../components/formStyles';

export function RolloutConfirm({ label, children, confirmLabel, cancelLabel = 'Go back', busy, onConfirm, onCancel }: {
  label: string;
  children: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div role="group" aria-label={label} className="mt-4 rounded-md bg-amber-50 p-4 ring-1 ring-amber-200" data-testid="rollout-confirm">
      <div className="space-y-2 text-sm text-amber-900">{children}</div>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <button type="button" className={primaryButtonClass} disabled={busy} onClick={onConfirm}>{busy ? 'Working…' : confirmLabel}</button>
        <button type="button" className={secondaryButtonClass} disabled={busy} onClick={onCancel}>{cancelLabel}</button>
      </div>
    </div>
  );
}
